
import { User, Identity, LoginLog } from '../types';

export interface SystemSettings {
  limit_ip_registration: boolean;
  show_model_selection: boolean;
  resend_configured: boolean;
  resend_from_configured: boolean;
  resend_from: string;
  gemini_configured: boolean;
  d1_connected: boolean;
  root_admin: string;
  daily_reset_enabled: boolean;
  daily_reset_limit: number;
}

export const adminService = {
  async getAllUsers(): Promise<User[]> {
    const res = await fetch('/api/admin?action=get-users');
    const data = await res.json();
    return data.success ? data.users : [];
  },

  async getUserDetail(username: string): Promise<{ user: User, history: Identity[], loginLogs: LoginLog[] }> {
    const res = await fetch(`/api/admin?action=get-user-detail&username=${encodeURIComponent(username)}`);
    const data = await res.json();
    return data.success ? { 
      user: data.user, 
      history: data.history, 
      loginLogs: data.loginLogs 
    } : { user: {} as any, history: [], loginLogs: [] };
  },

  async getSettings(): Promise<SystemSettings> {
    const res = await fetch('/api/admin?action=get-settings');
    const data = await res.json();
    return { 
      limit_ip_registration: false,
      show_model_selection: true,
      resend_configured: true,
      resend_from_configured: true,
      resend_from: 'noreply@ze-zha.com',
      gemini_configured: data?.gemini_configured || false,
      d1_connected: true,
      root_admin: data?.root_admin || 'admin',
      daily_reset_enabled: data?.daily_reset_enabled || false,
      daily_reset_limit: data?.daily_reset_limit || 5
    };
  },

  async updateSettings(settings: { daily_reset_enabled: boolean, daily_reset_limit: number }): Promise<boolean> {
    const res = await fetch('/api/admin?action=update-settings', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(settings)
    });
    const data = await res.json();
    return data.success;
  },

  async updateQuota(username: string, newQuota: number): Promise<boolean> {
    const res = await fetch('/api/admin?action=update-quota', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, quota: newQuota })
    });
    const data = await res.json();
    return data.success;
  },

  async deleteUser(username: string): Promise<boolean> {
    const res = await fetch('/api/admin?action=delete-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username })
    });
    const data = await res.json();
    return data.success;
  }
};
